import React from 'react'

import { useSettings } from '../../hooks/useSettings'

/**
 * Icon for Simulate Devices.
 * From flow-kwgt-svgrepo-com.svg (modified version)
 */
const SimulateDevicesSVG = ({ isActive, styles }) => {
  const { isDarkMode } = useSettings()

  const color = isDarkMode
    ? isActive
      ? '#8cb7ed'
      : '#ffffff'
    : isActive
      ? '#648cb5'
      : '#0E2E4C'

  const strokeProps = {
    stroke: color,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
  }

  return (
    <svg
      className={styles || 'w-[28px] desktop:w-[32px] h-[28px] desktop:h-[32px]'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer ellipse - linea marcata */}
      <ellipse
        cx="24.173101"
        cy="24.074091"
        rx="21.404688"
        ry="21.378338"
        {...strokeProps}
        strokeWidth="2.5"
      />
      <g transform="matrix(1.4075221,0,0,1.4075221,-7.2067286,-9.7320563)">
        <path
          d="m 25.4701,31.6918 c 0.6709,0.7579 1.651,1.2357 2.7428,1.2357 2.0223,0 3.6617,-1.6394 3.6617,-3.6617 0,-2.0223 -1.6394,-3.6617 -3.6617,-3.6617 H 11.9016"
          stroke={color}
          strokeWidth="1.8"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m 25.0398,16.4226 c 0.733,-0.8281 1.8039,-1.3501 2.9968,-1.3501 2.2096,0 4.0008,1.7912 4.0008,4.0008 0,2.2096 -1.7912,4.0008 -4.0008,4.0008 H 10.215"
          stroke={color}
          strokeWidth="1.8"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default SimulateDevicesSVG
